import { configureStore } from '@reduxjs/toolkit';
import apiCallStatesReducer from './reducers/api-call-state-reducer';

export default configureStore({
  reducer: {
    apiCallStates: apiCallStatesReducer
  },
  devTools: true
});
